import React, { useState, useEffect, useRef, useContext } from "react";
import {
  AppBar,
  Toolbar,
  makeStyles,
  Button,
  IconButton,
  Drawer,
  Grid,
  MenuItem,
  Box,
  Container,
  Typography,
  withStyles,
  Menu,
  Avatar,
  useTheme,
  useMediaQuery,
  Divider,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import { Link, useHistory, useLocation } from "react-router-dom";
import Logo from "./../../component/Logo";
import Scroll from "react-scroll";
import MuiDialogContent from "@material-ui/core/DialogTitle";
import MuiDialog from "@material-ui/core/Dialog";
import { useWeb3React } from "@web3-react/core";
import { UserContext } from "src/context/User";
import AccountBoxIcon from "@material-ui/icons/AccountBox";
import EditIcon from "@material-ui/icons/Edit";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import ConfirmationDialog from "src/component/ConfirmationDialog";
import ConnectModal from "src/component/ConnectModal";
import DisconnectModal from "src/component/DiconnectModal";
import { sortAddress } from "src/utils";

const ScrollLink = Scroll.Link;

const useStyles = makeStyles((theme) => ({
  drawerContainerText: {
    "& a": {
      color: "#b51632",
    },
    "& .nav a": {
      color: "#b51632",
    },
  },
  menuButton: {
    fontSize: "14px",
    lineHeight: "24px",
    fontWeight: "300",
    borderRadius: 0,
    minWidth: "auto",
    color: "#000",
    height: "31px",
    padding: "0px 10px",
    letterSpacing: "1px",
    marginLeft: "10px",
    backgroundColor: "#f4f4f4 !important",
    "& .nav a": {
      color: "#000",
    },
    "@media (max-width: 900px)": {
      fontStyle: "normal",
      letterSpacing: "-0.6px",
      lineHeight: "24px",
      color: "#000",
      padding: "15px !important",
      height: "51px",
      width: "100%",
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "flex-start",
    },
    "@media (max-width: 414px)": {
      padding: "12px !important",
      fontSize: "13px",
    },
    "@media (max-width: 375px)": {
      padding: "10px !important",
      fontSize: "12px",
    },
    "& .MuiMenu-list": {
      with: "193px !important",
    },
    "& a": {
      color: "#000",
    },
    "& .ul.navigation a": {
      color: "#000",
    },
    "&:hover": {
      backgroundColor: "#f4f4f4 !important",
      color: "#000 !important",
    },
    "&.activeMenu": {
      color: "#B3DAFF !important",
      fontWeight: "bold",
      position: "relative",
      "&:before": {
        content: "' '",
        position: "absolute",
        top: "26px",
        left: " 0px",
        width: "100%",
        height: "5px",
        background: "#B3DAFF",
        [theme.breakpoints.only("xs")]: {
          display: "none",
        },
      },
    },
    "& h6": {
      fontWeight: "400",
    },
  },
  toolbar: {
    display: "flex",
    padding: "6px 0",
    justifyContent: "space-between",
    height: "100%",
    width: "100%",
    maxWidth: "100vw",
    overflowX: "hidden",
    "@media (max-width: 900px)": {
      paddingLeft: "75px",
      paddingRight: "20px",
      height: "100%",
      width: "100%",
      margin: "0",
    },
    "@media (max-width: 414px)": {
      paddingLeft: "60px",
      paddingRight: "15px",
    },
    "@media (max-width: 375px)": {
      paddingLeft: "50px",
      paddingRight: "10px",
    },
  },

  drawerContainer: {
    padding: "20px 0px ",
    height: "100%",
    // background: '#06010D',
    backgroundColor: "#1d649c",
    width: "290px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "@media (max-width: 414px)": {
      width: "270px",
      padding: "15px 0px",
    },
    "@media (max-width: 375px)": {
      width: "250px",
      padding: "12px 0px",
    },
    "& a": {
      color: "#fff",
      "&:hover": {
        color: "#b51632",
        textDecoration: "none",
      },
    },
    "& .nav a": {
      color: "#b51632",
    },
  },
  drawericon: {
    color: "#000",
    position: "relative",
    fontSize: "25px",
    "@media (max-width: 414px)": {
      fontSize: "22px",
    },
    "@media (max-width: 375px)": {
      fontSize: "20px",
    },
  },
  logoImg: {
    marginTop: "5px",
    width: "192px",
    objectFit: "contain",
    "@media (max-width: 500px)": {
      width: "155px",
    },
    "@media (max-width: 414px)": {
      width: "140px",
    },
    "@media (max-width: 375px)": {
      width: "130px",
    },
  },
  containerHeight: {
    height: "100%",
    width: "100%",
    maxWidth: "100vw",
    overflowX: "hidden",
    "@media (max-width: 900px)": {
      padding: "0",
      margin: "0",
    },
  },
  appmain: {
    background: "#f4f4f4 !important",
    //     border: "none",
    position: "fixed",
    backdropFilter: "blur(4px) !important",
    width: "100%",
    zIndex: 1400,
    "@media (max-width: 900px)": {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      width: "100%",
      maxWidth: "100vw",
      overflowX: "hidden",
    },
  },

  mainHeader: {
    justifyContent: "space-between",
    padding: "0px",
    minHeight: "56px",
    width: "100%",
    maxWidth: "100vw",
    overflowX: "hidden",
    "@media (max-width: 414px)": {
      minHeight: "48px",
      padding: "0 8px",
    },
    "@media (max-width: 375px)": {
      minHeight: "44px",
      padding: "0 4px",
    },
  },
  wallet: {
    margin: " 0px 10px",
    backgroundColor: "#bfe0ff !important",
    color: "#000 !important",
    "&:hover": {
      backgroundColor: "#1a6196 !important",
      color: "#fff !important",
    },

    "@media (max-width: 900px)": {
      marginTop: "12px",
      backgroundColor: "#B3DAFF !important",
      color: "#000 !important",
      boxShadow: "none",
      borderRadius: "50px",
      fontSize: "14px",
      padding: "8px 16px",
    },
    "@media (max-width: 414px)": {
      fontSize: "13px",
      padding: "6px 12px",
      marginTop: "10px",
    },
    "@media (max-width: 375px)": {
      fontSize: "12px",
      padding: "5px 10px",
      marginTop: "8px",
    },
  },

  activeBlock: {
    position: "relative",
    color: "#B3DAFF !important",
    fontWeight: "bold",
    textDecorationThickness: "3px",
    "&::before": {
      top: "24px",
      width: "calc(100% - 21px)",
      height: "2px",
      content: "''",
      position: "absolute",
      background: "#B3DAFF",
    },
  },
  nameSymbol: {
    // border: "1px solid #ccc",
    background: "#B3DAFF",
    width: "42px",
    height: "42px",
    borderRadius: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& h4": {
      fontSize: "18px",
      fontWeight: "600",
      textTransform: "uppercase",
      color: "#000 !important",
    },
    "& .MuiTypography-root": {
      color: "#000 !important",
    },
    "& *": {
      color: "#000 !important",
    },
  },
  MenuItemshover: {},
  flexbox: {},
}));
const StyledMenu = withStyles({
  paper: {
    marginTop: "10px",
    backgroundColor: "#ffffff",
    color: "#1a1a1a",
    zIndex: 1500,
    border: "1px solid #e9ecef",
    borderRadius: 12,
    boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
    "& .MuiList-root": {
      padding: 8,
      backgroundColor: "#ffffff",
      color: "#1a1a1a",
    },
    "& .MuiMenuItem-root": {
      backgroundColor: "#ffffff",
      color: "#1a1a1a",
      borderRadius: 8,
      margin: "2px 4px",
      padding: "10px 14px",
      minWidth: 180,
      transition: "background-color 0.2s ease, transform 0.1s ease",
      "& .MuiSvgIcon-root": {
        color: "#1a1a1a",
      },
      "&:hover": {
        backgroundColor: " #f0f2f5",
        transform: "translateY(-1px)",
        "& .MuiSvgIcon-root": {
          color: "#ffffff",
        },
      },
    },
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "center",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "center",
    }}
    PaperProps={{}}
    MenuListProps={{}}
    {...props}
  />
));
export default function Header() {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  
  const user = useContext(UserContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const location = useLocation();
  const [openLogout, setOpenLogout] = useState(false);
  const { account } = useWeb3React();
  const [openDisconnect, setOpenDisConnect] = useState(false);

  const handlescroll = () => {
    if (location.pathname === "/") {
      window.scrollTo({ top: 2000, behavior: "smooth" });
    } else {
      history.push("/");
    }
  };
  const handlescrollHolders = () => {
    if (location.pathname === "/") {
      window.scrollTo({ top: 1000, behavior: "smooth" });
    } else {
      history.push("/");
    }
  };
  const handlescrollTop = () => {
    if (location.pathname === "/") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      history.push("/");
    }
  };
  const handlescroll3 = () => {
    if (location.pathname === "/") {
      window.scrollTo({ top: 3900, behavior: "smooth" });
    } else {
      history.push("/");
    }
  };
  const handlescrollTeam = () => {
    if (location.pathname === "/") {
      window.scrollTo({ top: 5000, behavior: "smooth" });
    } else {
      history.push("/");
    }
  };

  const {
    flexbox,
    menuButton,
    toolbar,
    drawerContainer,
    drawerContainerText,
    drawericon,
    containerHeight,
    appmain,
    mainHeader,
    wallet,
    activeBlock,
    nameSymbol,
    MenuItemshover,
  } = useStyles();
  const history = useHistory();
  const [state, setState] = useState({
    mobileView: false,
    drawerOpen: false,
  });
  const { mobileView, drawerOpen } = state;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    const setResponsiveness = () => {
      return window.innerWidth < 1024
        ? setState((prevState) => ({ ...prevState, mobileView: true }))
        : setState((prevState) => ({ ...prevState, mobileView: false }));
    };
    setResponsiveness();
    window.addEventListener("resize", () => setResponsiveness());
  }, []);

  const [activeSet, setActiveSet] = useState("Home");
  useEffect(() => {
    if (location.pathname === "/") {
      setActiveSet("Home");
    } else if (location.pathname === "/marketplace") {
      setActiveSet("marketplace");
    } else if (location.pathname === "/brands") {
      setActiveSet("brands");
    } else if (location.pathname === "/wineries") {
      setActiveSet("wineries");
    } else if (location.pathname === "/infrastructure") {
      setActiveSet("Dashboard");
    } else if (location.pathname === "/transaction-management") {
      setActiveSet("class");
    } else if (location.pathname === "/institute") {
      setActiveSet("institute");
    } else if (location.pathname === "/plot") {
      setActiveSet("plot");
    } else if (location.pathname === "/profile") {
      setActiveSet("profile");
    } else if (location.pathname === "/blog-list") {
      setActiveSet("Blog");
    } else {
      setActiveSet("");
    }
  }, [location]);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  function nameSybmolCreator(first, last) {
    const firstName = first?.slice(0, 1);
    const lastName = last?.slice(0, 1);
    const shortForm = `${firstName}${lastName}`;
    return shortForm;
  }
  const displayDesktop = () => {
    return (
      <Container maxWidth="lg" className="p-0">
        <Toolbar className={toolbar}>
          {/* LEFT SECTION - Navigation Menu */}
          <Grid container alignItems="center" style={{ flexWrap: "nowrap" }}>
            <Grid item style={{ flex: "0 0 auto", marginLeft: "-15px" }}>
              <nav>
                <ul className="navigation" style={{ display: "flex", alignItems: "center", margin: 0, padding: 0, listStyle: "none" }}>
                  <li>
                    <MenuItem
                      exact
                      activeClassName="activeMenu"
                      className={[
                        menuButton,
                        activeSet === "Home" ? activeBlock : null,
                      ]}
                      onClick={() => {
                        handlescrollTop();
                        setActiveSet("Home");
                      }}
                      style={{ paddingLeft: "10px", minWidth: "auto" }}
                    >
                      Home
                    </MenuItem>
                  </li>
                  <li>
                    <MenuItem
                      className={[
                        menuButton,
                        activeSet === "marketplace" ? activeBlock : null,
                      ]}
                      onClick={() => history.push("/marketplace")}
                    >
                      Marketplace
                    </MenuItem>
                  </li>
                  <li>
                    <MenuItem
                      className={[
                        menuButton,
                        activeSet === "brands" ? activeBlock : null,
                      ]}
                      onClick={() => history.push("/brands")}
                    >
                      Brands
                    </MenuItem>
                  </li>
                  <li>
                    <MenuItem
                      className={[
                        menuButton,
                        activeSet === "AboutUs" ? activeBlock : null,
                      ]}
                      onClick={() => {
                        history.push("/Topcreater#about-us");
                        setActiveSet("Topcreater");
                      }}
                    >
                      About-Us
                    </MenuItem>
                  </li>
                  {user?.userData?.userType === "ADMIN" &&
                    window.localStorage.getItem("token") && (
                      <li>
                        <MenuItem
                          className={[
                            menuButton,
                            activeSet === "Dashboard" ? activeBlock : null,
                          ]}
                          onClick={() => history.push("/transaction-management")}
                        >
                          Dashboard
                        </MenuItem>
                      </li>
                    )}
                </ul>
              </nav>
            </Grid>

            {/* CENTER SECTION - Logo */}
            <Grid item style={{ flex: "1 1 auto", display: "flex", justifyContent: "center" }}>
              {femmecubatorLogo}
            </Grid>

            {/* RIGHT SECTION - User Actions */}
            <Grid item style={{ flex: "0 0 auto" }}>
              <Box display="flex" alignItems="center" style={{ gap: "10px" }}>
                {/* Search Button */}
                <IconButton
                  style={{ padding: "0px", background: "#f5f5f5" }}
                  onClick={() => history.push("/search-data")}
                >
                  {/* <img
                    src="/images/images.png"
                    alt="search"
                    width="25px"
                  /> */}
                </IconButton>

                {/* Wallet/Login */}
                {user?.userLoggedIn && (
                  <>
                    {!account && (
                      <Button
                        variant="contained"
                        // color="primary"
                        className={wallet}
                        onClick={() => user.setIsOpenConnectWallet(true)}
                      >
                        Connect Wallet
                      </Button>
                    )}
                    {account && (
                      <Button
                        variant="contained"
                        // color="primary"
                        className={wallet}
                        onClick={() => setOpenDisConnect(true)}
                      >
                        {`Disconnect ${sortAddress(account)}`}
                      </Button>
                    )}
                  </>
                )}

                {/* Account Menu / Login */}
                {window.localStorage.getItem("token") &&
                window.localStorage.getItem("token") ? (
                  <IconButton
                    className={[menuButton]}
                    aria-label="delete"
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    onClick={handleClick}
                    size="small"
                  >
                    {user?.userData?.profilePic ? (
                      <Avatar
                        src={user?.userData?.profilePic}
                        alt={user?.userData?.firstName || "User"}
                        style={{ width: 42, height: 42 }}
                      />
                    ) : user?.userData?.firstName && user?.userData?.lastName ? (
                      <Box className={nameSymbol}>
                        <Typography variant="h4" style={{ color: "#B3DAFF !important" }}>
                          {nameSybmolCreator(
                            user?.userData?.firstName,
                            user?.userData?.lastName
                          )}
                        </Typography>
                      </Box>
                    ) : (
                      <Avatar style={{ width: 42, height: 42, backgroundColor: "#B3DAFF" }} />
                    )}
                  </IconButton>
                ) : (
                  <Button
                    variant="contained"
                    // color="primary"
                    className={wallet}
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    onClick={() => history.push("/login")}
                  >
                    Login
                  </Button>
                )}
              </Box>
            </Grid>
          </Grid>

          {/* Account Menu Dropdown */}
          {window.localStorage.getItem("token") && (
            <Box>
              <StyledMenu
                id="simple-menu"
                disableScrollLock={true}
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                style={{ zIndex: 1500 }}
              >
                <Box px={1.5} py={1}
                  style={{display:'flex', alignItems:'center', gap:10, minWidth:200}}
                >
                  <Avatar style={{ width: 32, height: 32 }} src={user?.userData?.profilePic}>
                    {!user?.userData?.profilePic && (user?.userData?.firstName || 'U')?.[0]}
                  </Avatar>
                  <Box>
                    <Typography style={{fontSize:13, fontWeight:600, color:'#1a1a1a'}}>
                      {user?.userData?.firstName} {user?.userData?.lastName}
                    </Typography>
                    <Typography style={{fontSize:11, color:'#666'}}>
                      {user?.userData?.email}
                    </Typography>
                  </Box>
                </Box>
                <Divider />
                <MenuItem
                  className={MenuItemshover}
                  onClick={() => {
                    handleClose();
                    history.push("/author-profile");
                  }}
                >
                  <AccountBoxIcon style={{ marginRight: 10 }} />
                  <Typography style={{ fontSize: 14 }}>Profile</Typography>
                </MenuItem>

                <MenuItem
                  className={MenuItemshover}
                  onClick={() => {
                    handleClose();
                    history.push("/update-profile");
                  }}
                >
                  <EditIcon style={{ marginRight: 10 }} />
                  <Typography style={{ fontSize: 14 }}>Edit Profile</Typography>
                </MenuItem>
                <MenuItem
                  className={MenuItemshover}
                  onClick={() => {
                    handleClose();
                    setOpenLogout(true);
                  }}
                >
                  <ExitToAppIcon style={{ marginRight: 10 }} />
                  <Typography style={{ fontSize: 14 }}>Logout</Typography>
                </MenuItem>
              </StyledMenu>
            </Box>
          )}
        </Toolbar>
      </Container>
    );
  };
  const displayMobile = () => {
    const handleDrawerToggle = () =>
      setState((prevState) => ({ ...prevState, drawerOpen: !prevState.drawerOpen }));
    const handleDrawerClose = () =>
      setState((prevState) => ({ ...prevState, drawerOpen: false }));

    return (
      <Toolbar className={mainHeader}>
        <Drawer
          {...{
            anchor: "right",
            open: drawerOpen,
            onClose: handleDrawerClose,
            style: { zIndex: 1300 }
          }}
        >
          <div className={drawerContainer}>
            <Box className="drawer2"></Box>
            {getDrawerChoices(handleDrawerClose)}
            <Box width="100%">
              {!window.localStorage.getItem("token") && (
                <>
                  <Box mt={1}>
                    <Button
                      variant="contained"
                      color="primary"
                      className={wallet}
                      aria-controls="simple-menu"
                      aria-haspopup="true"
                      onClick={() => history.push("/login")}
                    >
                      Login
                    </Button>
                  </Box>
                </>
              )}

              {window.localStorage.getItem("token") && (
                <Box mt={1}>
                  <Button
                    variant="contained"
                    color="primary"
                    className={wallet}
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    onClick={() => setOpenLogout(true)}
                  >
                    Logout
                  </Button>
                </Box>
              )}
              {user?.userLoggedIn && (
                <>
                  <Box mt={2}>
                    {!account && (
                      <Button
                        variant="contained"
                        color="primary"
                        className={wallet}
                        onClick={() => user.setIsOpenConnectWallet(true)}
                      >
                        Connect Wallet
                      </Button>
                    )}
                    {account && (
                      <Button
                        variant="contained"
                        color="primary"
                        className={wallet}
                        onClick={() => setOpenDisConnect(true)}
                      >
                        {`Disconnect ${sortAddress(account)}`}
                      </Button>
                    )}
                  </Box>
                </>
              )}
            </Box>
          </div>
        </Drawer>
        <Grid
          container
          style={{
            alignItems: "center",
            width: "100%",
            maxWidth: "100vw",
            margin: "0",
            padding: "0",
            overflowX: "hidden",
          }}
        >
          <Grid item xs={6} sm={8} md={10} style={{ 
            padding: "0 8px",
            overflow: "hidden",
          }}>
            {" "}
            <div>{femmecubatorLogo}</div>
          </Grid>
          <Grid item xs={6} sm={4} md={2} style={{
            display: "flex",
            justifyContent: "flex-end",
            overflow: "hidden",
          }}>
            <Box
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                padding: "0 8px",
                minHeight: "48px",
              }}
            >
              <IconButton
                className={drawericon}
                {...{
                  edge: "end",
                  color: "inherit",
                  "aria-label": "menu",
                  "aria-haspopup": "true",
                  onClick: handleDrawerToggle,
                }}
                style={{
                  padding: "8px",
                  margin: "0",
                  minWidth: "48px",
                  minHeight: "48px",
                }}
              >
                <MenuIcon
                  style={{ 
                    color: "#1d649c", 
                    fontSize: window.innerWidth <= 375 ? "24px" : window.innerWidth <= 414 ? "26px" : "30px",
                    width: window.innerWidth <= 375 ? "24px" : window.innerWidth <= 414 ? "26px" : "30px",
                    height: window.innerWidth <= 375 ? "24px" : window.innerWidth <= 414 ? "26px" : "30px",
                  }}
                />
              </IconButton>
            </Box>
          </Grid>
        </Grid>
      </Toolbar>
    );
  };
  const getDrawerChoices = (handleDrawerClose) => {
    return (
      <>
        <nav className={drawerContainerText}>
          <input type="checkbox" id="check" />
          <label clasnames="logo">
            <img
              src="/images/tokenate.png"
              alt="Logo"
              width="100%"
              style={{ width: "100%", maxWidth: "150px" }}
            />
          </label>
          <ul className="navigation">
            <ScrollLink
              onClick={() => {
                handlescrollTop();
                handleDrawerClose(); //callbackFunction
              }}
              className="hovertext"
              smooth={true}
              duration={500}
              to="Home"
              style={{ cursor: "pointer" }}
            >
              <Typography
                variant="h6"
                paragraph
                className={`${classes.typosec} hovertext`}
              >
                Home
              </Typography>
            </ScrollLink>

            {user?.userData?.userType === "ADMIN" &&
              window.localStorage.getItem("token") && (
                <ScrollLink
                  onClick={() => history.push("/transaction-management")}
                  className="hovertext"
                  smooth={true}
                  duration={500}
                  style={{ cursor: "pointer" }}
                >
                  <Typography
                    variant="h6"
                    paragraph
                    className={`${classes.typosec} hovertext`}
                    style={{
                      fontSize: isMobile ? "0.9rem" : isTablet ? "1rem" : "1.1rem",
                      padding: isMobile ? "8px 0" : isTablet ? "10px 0" : "12px 0",
                    }}
                  >
                    Dashboard
                  </Typography>
                </ScrollLink>
              )}

            <ScrollLink
              onClick={() => history.push("/marketplace")}
              className="hovertext"
              smooth={true}
              duration={500}
              style={{ cursor: "pointer" }}
            >
              <Typography
                variant="h6"
                paragraph
                className={`${classes.typosec} hovertext`}
              >
                Marketplace
              </Typography>
            </ScrollLink>

            <ScrollLink
              onClick={() => history.push("/brands")}
              className="hovertext"
              smooth={true}
              duration={500}
              style={{ cursor: "pointer" }}
            >
              <Typography
                variant="h6"
                paragraph
                className={`${classes.typosec} hovertext`}
              >
                Brands
              </Typography>
            </ScrollLink>

            {/* <ScrollLink
              onClick={() => history.push("/wineries")}
              className="hovertext"
              smooth={true}
              duration={500}
              style={{ cursor: "pointer" }}
            >
              <Typography
                variant="h6"
                paragraph
                className={`${classes.typosec} hovertext`}
              >
                Wineries
              </Typography>
            </ScrollLink> */}

            {window.localStorage.getItem("token") && (
              <ScrollLink
                onClick={() => history.push("/author-profile")}
                className="hovertext"
                smooth={true}
                duration={500}
                style={{ cursor: "pointer" }}
              >
                <Typography
                  variant="h6"
                  paragraph
                  className={`${classes.typosec} hovertext`}
                >
                  Profile
                </Typography>
              </ScrollLink>
            )}
          </ul>
        </nav>
      </>
    );
  };
  const femmecubatorLogo = (
    <Box onClick={handlescrollTop}>
      <Link to="/">
        <Logo className={classes.logoImg} />
      </Link>
    </Box>
  );

  return (
    <>
      <style>{`
        @media (max-width: 900px) {
          body {
            overflow-x: hidden !important;
            max-width: 100vw !important;
          }
          html {
            overflow-x: hidden !important;
            max-width: 100vw !important;
          }
        }
      `}</style>
      <AppBar
        position={history.location.pathname !== "/" ? "relative" : "absolute"}
        elevation={0}
        className={appmain}
      >
        <Box
          maxWidth={history.location.pathname !== "/" ? "lg" : "fixed"}
          className={containerHeight}
          sx={{
            width: "100%",
            maxWidth: "100vw",
            overflowX: "hidden",
            margin: "0",
            padding: "0",
          }}
        >
          {mobileView ? displayMobile() : displayDesktop()}
        </Box>
      </AppBar>
      <ConfirmationDialog
        open={openLogout}
        handleClose={() => setOpenLogout(false)}
        title={"Logout"}
        desc={"Do you want to Logout ?"}
      />
      <ConnectModal
        user={user}
        account={account}
        setOpen={() => user.setIsOpenConnectWallet(false)}
        open={user.isOpenConnectWallet}
      />
      <DisconnectModal
        user={user}
        open={openDisconnect}
        onClose={() => setOpenDisConnect(false)}
      />
    </>
  );
}




// "use client";
// import React from "react";
// import AppBar from "@material-ui/core/AppBar";
// import Toolbar from "@material-ui/core/Toolbar";
// import IconButton from "@material-ui/core/IconButton";
// import Menu from "@material-ui/core/Menu";
// import MenuItem from "@material-ui/core/MenuItem";
// import Button from "@material-ui/core/Button";
// import Box from "@material-ui/core/Box";
// import MenuIcon from "@material-ui/icons/Menu";

// export default function Header() {
//   const [anchorEl, setAnchorEl] = React.useState(null);
//   const [servicesAnchor, setServicesAnchor] = React.useState(null);

//   const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
//   const handleMenuClose = () => setAnchorEl(null);

//   const handleServicesOpen = (event) => setServicesAnchor(event.currentTarget);
//   const handleServicesClose = () => setServicesAnchor(null);

//   return (
//     <AppBar
//       position="static"
//       elevation={1}
//       style={{ backgroundColor: "black", color: "white" }}
//     >
//       <Toolbar style={{ display: "flex", justifyContent: "space-between" }}>
//         {/* LEFT: Desktop Menu */}
//         <Box display={{ xs: "none", sm: "flex" }} style={{ gap: "16px" }}>
//           <Button href="/" style={{ color: "white" }}>
//             Home
//           </Button>
//           <Button href="/marketplace" style={{ color: "white" }}>
//             marketplace
//           </Button>
//           <Button href="/brands" style={{ color: "white" }}>
//             brands
//           </Button>

//           {/* Services submenu */}
//           <Box display="inline-block">
//             <Button
//               style={{ color: "white" }}
//               onClick={handleServicesOpen}
//               aria-controls="services-menu"
//               aria-haspopup="true"
//             >
//               Services
//             </Button>
//             <Menu
//               id="services-menu"
//               anchorEl={servicesAnchor}
//               open={Boolean(servicesAnchor)}
//               onClose={handleServicesClose}
//               getContentAnchorEl={null}
//               anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
//               transformOrigin={{ vertical: "top", horizontal: "left" }}
//             >
//               <MenuItem
//                 component="a"
//                 href="https://www.tokenate.ai/blank"
//                 onClick={handleServicesClose}
//               >
//                 Tokenization Lifecycle Management
//               </MenuItem>
//               <MenuItem
//                 component="a"
//                 href="https://www.tokenate.ai/blank-1"
//                 onClick={handleServicesClose}
//               >
//                 Security, Compliance, and Regulatory Ass
//               </MenuItem>
//               <MenuItem
//                 component="a"
//                 href="https://www.tokenate.ai/blank-1-1"
//                 onClick={handleServicesClose}
//               >
//                 Interoperability, Analytics, and Client
//               </MenuItem>
//             </Menu>
//           </Box>

//           <Button href="https://www.tokenate.ai/contact" style={{ color: "white" }}>
//             Contact
//           </Button>
//         </Box>

//         {/* CENTER: Logo */}
//         <Box display="flex" justifyContent="start" flexGrow={1}>
//           <img
//             src="/images/logo.svg"
//             alt="tokenate"
//             style={{ width: 150, height:60 ,marginLeft: "25%"}}
//           />
//         </Box>

//         {/* RIGHT: Mobile Menu Icon */}
//         <Box display={{ xs: "flex", sm: "none" }}>
//           <IconButton
//             size="medium"
//             edge="end"
//             style={{ color: "white" }}
//             aria-label="menu"
//             onClick={handleMenuOpen}
//           >
//             <MenuIcon />
//           </IconButton>
//         </Box>
//       </Toolbar>

//       {/* Mobile Menu */}
//       <Menu
//         anchorEl={anchorEl}
//         open={Boolean(anchorEl)}
//         onClose={handleMenuClose}
//         getContentAnchorEl={null}
//         anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
//         transformOrigin={{ vertical: "top", horizontal: "right" }}
//       >
//         <MenuItem component="a" href="https://www.tokenate.ai">
//           Home
//         </MenuItem>
//         <MenuItem component="a" href="https://www.tokenate.ai">
//           About Us
//         </MenuItem>
//         <MenuItem component="a" href="https://www.tokenate.ai/solutions">
//           Solutions
//         </MenuItem>

//         {/* Services submenu */}
//         <MenuItem onClick={handleServicesOpen}>Services</MenuItem>
//         <Menu
//           id="mobile-services"
//           anchorEl={servicesAnchor}
//           open={Boolean(servicesAnchor)}
//           onClose={handleServicesClose}
//           getContentAnchorEl={null}
//           anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
//           transformOrigin={{ vertical: "top", horizontal: "right" }}
//         >
//           <MenuItem
//             component="a"
//             href="https://www.tokenate.ai/blank"
//             onClick={handleServicesClose}
//           >
//             Tokenization Lifecycle Management
//           </MenuItem>
//           <MenuItem
//             component="a"
//             href="https://www.tokenate.ai/blank-1"
//             onClick={handleServicesClose}
//           >
//             Security, Compliance, and Regulatory Ass
//           </MenuItem>
//           <MenuItem
//             component="a"
//             href="https://www.tokenate.ai/blank-1-1"
//             onClick={handleServicesClose}
//           >
//             Interoperability, Analytics, and Client
//           </MenuItem>
//         </Menu>

//         <MenuItem component="a" href="https://www.tokenate.ai/contact">
//           Contact
//         </MenuItem>
//       </Menu>
//     </AppBar>
//   );
// }
